import * as actions from './measurementMaster/actions'
import * as mutations from './measurementMaster/mutations'
import * as getters from './measurementMaster/getters'

import { measurementListProps } from './measurementMaster/properties'

const state = {
    list: [JSON.parse(JSON.stringify(measurementListProps))],
    deleted_measurement_list_items: [],
    item_type: 0//tailoring product, fabric, ready to wear, raw material, asset
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/measurementMaster.js